import {MomentDateAdapter} from "@angular/material-moment-adapter";
import {Inject, Optional} from "@angular/core";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import * as moment from "moment";

export class MomentUtcDateAdapter extends MomentDateAdapter {

    constructor(@Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string) {
        super(dateLocale);
    }

    parse(value: any, parseFormat: string | string[]): moment.Moment | null {
        console.log(value);
        return super.parse(value, parseFormat);
    }

    format(date: moment.Moment, displayFormat: string): string {
        return super.format(date, displayFormat);
    }

    createDate(year: number, month: number, date: number): moment.Moment {
        // Moment.js will create an invalid date if any of the components are out of bounds, but we
        // explicitly check each case so we can throw more descriptive errors.
        if (month < 0 || month > 11) {
            throw Error(`Invalid month index "${month}". Month index has to be between 0 and 11.`);
        }

        if (date < 1) {
            throw Error(`Invalid date "${date}". Date has to be greater than 0.`);
        }

        const result = moment.utc({year, month, date}).startOf('day').locale(this.locale);

        // If the result isn't valid, the date must have been out of bounds for this month.
        if (!result.isValid()) {
            throw Error(`Invalid date "${date}" for month with index "${month}".`);
        }

        return result;
    }

}
